import { writable } from 'svelte/store';
import { calculateRecommendation } from '../utils/recommendationLogic.js';

// Initial state
const initialState = {
  currentScreen: 'edu', // edu, q1, q2, q3, q4, loading, result, emailCapture, faq, success
  currentStep: 0, // 0=edu, 1=q1, 2=q2, 3=q3, 4=q4, 5=result
  answers: {
    q1: null,
    q2: null,
    q3: null,
    q4: null
  },
  recommendation: null, // { plan, premiumFlag, corporateFlag }
  email: null,
  emailCaptureType: null, // 'transactional' or 'marketing'
  loading: false,
  error: null
};

function createSurveyStore() {
  const { subscribe, set, update } = writable(initialState);

  return {
    subscribe,
    
    // Navigation
    goToScreen: (screen, step) => update(state => ({
      ...state,
      currentScreen: screen,
      currentStep: step !== undefined ? step : state.currentStep
    })),
    
    // Answer handling
    setAnswer: (question, tag, text) => update(state => ({
      ...state,
      answers: {
        ...state.answers,
        [question]: { tag, text }
      }
    })),
    
    // Calculate recommendation based on answers
    calculateRecommendation: () => update(state => {
      const { q1, q2, q3, q4 } = state.answers;
      
      if (!q1 || !q2 || !q3 || !q4) {
        return state; // Not all questions answered yet
      }
      
      const recommendation = calculateRecommendation(
        q1.tag,
        q2.tag,
        q3.tag,
        q4.tag
      );
      
      return {
        ...state,
        recommendation
      };
    }),
    
    // Email capture
    setEmail: (email, captureType) => update(state => ({
      ...state,
      email,
      emailCaptureType: captureType // 'transactional' or 'marketing'
    })),
    
    // Loading states
    setLoading: (loading) => update(state => ({ ...state, loading })),
    setError: (error) => update(state => ({ ...state, error })),
    
    // Reset
    reset: () => set(initialState)
  };
}

export const surveyStore = createSurveyStore();
